import type { ReactNode } from "react";

import { ScrollArea } from "../ui/scroll-area";

/** Keep the same full-width canvas through loading, errors and ready content. */
export function ConnectionsPageFrame({
  children,
  toolbar,
}: {
  readonly children: ReactNode;
  readonly toolbar?: ReactNode;
}) {
  return (
    <ScrollArea className="h-full w-full flex-1 bg-background">
      <div className="flex min-h-full w-full flex-col">
        {toolbar}
        <div data-slot="connections-content" className="w-full flex-1 px-4 py-6 sm:px-6 lg:px-8">
          {children}
        </div>
      </div>
    </ScrollArea>
  );
}
